<script>
import Header from "@/components/Header.vue";
import Content from "@/components/Content.vue";

export default {
  name: "HomeView",
  components: {Content, Header}
}
</script>

<template>
  <div id="home">
    <Header></Header>
    <Content></Content>
  </div>
</template>

<style scoped>

/*#home {
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/banner.png") no-repeat;
  background-size: 100% 50%;
  padding-top: 0px;
}*/

</style>
